import styled from 'styled-components/macro';
export const LinkButton = styled.button`
    background: none !important;
    border: none;
    padding: 0 !important;
    outline: none;
    /*optional*/
    font-family: inherit;
    font-size: inherit;
    /*input has OS specific font-family*/
    color: inherit;
    background-color: inherit;
    text-decoration: none;
    cursor: pointer;
    text-align: left;
    &:hover {
        text-decoration: underline;
    }
`;
